import CloseIcon from '@mui/icons-material/Close';
import {DialogActions} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import React from 'react';

import {pxToRem} from '../../utils';
import CustomButtonGroup from '../CustomButtonGroup/CustomButtonGroup';

const CustomDrawer = ({open, anchor, onToggleOff, title, widthPerc, children, actionButtons, showDialogActions}) => {
  return (
    <Drawer
      open={open}
      anchor={anchor}
      PaperProps={{
        sx: {
          height: '100vh',
          width: `${widthPerc ? `${widthPerc}%` : '50%'}`,
          borderRadius: pxToRem(4),
        },
      }}
      onClose={() => onToggleOff(!open)}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          fontWeight: 800,
          color: (theme) => theme.palette.primary.dark,
        }}
      >
        {title}
        <IconButton
          aria-label="close"
          onClick={() => onToggleOff(!open)}
          sx={{
            position: 'absolute',
            right: pxToRem(16),
            top: pxToRem(8),
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{p: 0}} dividers>
        {children}
      </DialogContent>
      {showDialogActions && (
        <DialogActions>
          {Array.isArray(actionButtons) && actionButtons.length > 1 && (
            <CustomButtonGroup
              first={{
                ...actionButtons[0],
              }}
              second={{
                ...actionButtons[1],
              }}
            />
          )}
        </DialogActions>
      )}
    </Drawer>
  );
};

export default CustomDrawer;
